import converter from 'number-to-words';

export const NumberToWords = ({amount}) => {
  if (isNaN(amount)) return "";

  // Split into whole number and decimals
  const [rupees, paisa] = amount.toString().split('.');

  // Convert Rupees to words
  // Note: For true Indian System (Lakhs), we use a specific regex or a dedicated INL library
  // If you need strict 'Lakh' terminology, 'numb-to-words' is actually the winner here.
  
  let result = `${converter.toWords(rupees)} rupees`;

  if (paisa) {
    // Ensure two decimal places (e.g., .8 becomes 80 paisa)
    const formattedPaisa = paisa.length === 1 ? paisa + '0' : paisa.slice(0, 2);
    result += ` and ${converter.toWords(formattedPaisa)} paisa`;
  }

  return <span style={{textTransform:"capitalize"}}>{result}</span>;
};